import React, { useState } from "react";


import API from '../../tools/API';
import style from './Modal.module.scss';

interface AddSetting {
    openModal: (arg: boolean) => void;
}

const AddSettingModal: React.FC<AddSetting> = ({ openModal }) => {
    const [name, setName] = useState('');
    const [sms, setSms] = useState(false);
    const [resultsNumber, setResultsNumber] = useState(0);
    const [maxTime, setMaxTime] = useState(0);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);


    const makeNewSetting = () => {
        if (name) {
            API.postNewSetting(name, sms, resultsNumber, maxTime)
                .then(res => {
                    openModal(false);
                    setLoading(false);
                })
                .catch(err => {
                    setLoading(false);
                    setError(err.response.data.Exception);
                })
        } else {
            setLoading(false);
            setError('Nazwa ustawienia musi być uzupełniona!');
        }
    }

    return (
        <div className={style.AddCathegory}>
            <h2 className={style.AddCathegory__title} >Dodaj ustawienie</h2>
            <form className={style.AddCathegory__form}>
                <input
                    type="text"
                    id="settingName"
                    placeholder="Nazwa"
                    className={style.AddCathegory__formInput}
                    value={name}
                    onChange={(e) => {
                        setName(e.target.value)
                    }}
                />
                <label
                    htmlFor="resultsNumber"
                    className={style.AddCathegory__formLabelNumber}
                >
                    Liczba wyników:
                </label>
                <input
                    type="number"
                    id="resultsNumber"
                    className={style.AddCathegory__formInput}
                    value={resultsNumber}
                    onChange={(e) => {
                        setResultsNumber(parseInt(e.target.value))
                    }}
                />
                <label
                    htmlFor="maxTime"
                    className={style.AddCathegory__formLabelNumber}
                >
                    Maksymalny czas głosu na opcję:
                </label>
                <input
                    type="number"
                    id="maxTime"
                    className={style.AddCathegory__formInput}
                    value={maxTime}
                    onChange={(e) => {
                        setMaxTime(parseInt(e.target.value))
                    }}
                />
                <div className={style.AddCathegory__container}>
                    <label
                        htmlFor="smsVoting"
                        className={style.AddCathegory__formLabel}
                    >
                        Głosowanie SMS:
                    </label>
                    <input
                        type="checkbox"
                        id="smsVoting"
                        name="smsVoting"
                        className={style.AddCathegory__checkbox}
                        checked={sms}
                        onChange={(e) => {
                            setSms(e.target.checked)
                        }}
                    />
                </div>
                {!loading ? <input
                    type="button"
                    value="DODAJ"
                    className={style.AddCathegory__button}
                    onClick={(e) => {
                        e.preventDefault();
                        setLoading(true);
                        makeNewSetting();
                    }}
                /> : <p className={style.loader}>Trwa dodawanie...</p>
                }
                {error &&
                    <div className={style.addPoll__row}>
                        <p className={style.errorText}>{error}</p>
                    </div>
                }
            </form>
        </div>
    )
}

export default AddSettingModal;